import { styled } from "@mui/material/styles"
import Background from "../Background"

export const StyledBackground = styled(Background)(() => ({
  overflowY: "auto",
  overflowX: "hidden",
}))
